import { render } from "./LoginForm.vue?vue&type=template&id=7389c6a8"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script